import {Row, Text, View} from '@unthinkable/react-core-components';
import moment from 'moment';
import {
  UserAvatar,
  UserAvatarChip,
} from '../../../components/avatar/UserAvatar';
import {Tag} from '../../../components/chip/Chip';
import {Table} from '../../../components/table/Table';

const renderStatus = ({row = {}, styles = {}, field}) => {
  let {status} = row;
  let updateColor = {color: '#34C759'};
  let updateValue = '';
  let background = '';
  let {rowText = {}} = styles;
  if (status === 'approve') {
    updateColor['color'] = '#34C759';
    updateValue = 'Approved';
    background = '#F0FFF4';
  } else if (status === 'reject') {
    updateColor['color'] = '#FF3B30';
    updateValue = 'Rejected';
    background = '#FFF1F0';
  } else {
    updateColor['color'] = '#007AFF';
    updateValue = 'Unapproved';
    background = '#E0F5FF';
  }
  return (
    <View
      style={{
        backgroundColor: background,
        padding: 6,
        alignItem: 'center',
        textAlign: 'center',
      }}>
      <Text style={{...rowText, ...updateColor}}>{updateValue || '-'}</Text>
    </View>
  );
};

export const WFHRequestTable = props => {
  let {
    navigation,
    route: {params},
    filter,
    searchValue,
    filterParams,
    periods,
    tab,
  } = props;

  const {period, ...rest} = params;
  let sort = {};
  if (tab == 'open') {
    sort = {requested_on: -1};
  } else if (tab == 'closed') {
    sort = {updatedAt: -1};
  }
  params = {
    ...rest,
  };
  params = {...params, ...filterParams, periods};
  return (
    <Table
      api={'/wfhrequest/self'}
      params={params}
      eventSourceId={'wfhRequest'}
      addOnFilter={filter}
      search={searchValue}
      sort={{...sort}}
      //   onRowPress={({row}) => {
      //     navigation.navigate(`update-leave-request`, {
      //       row,
      //     });
      //   }}
      columns={[
        {
          header: 'Requested On',
          type: 'date',
          render: ({row, styles: {rowText}}) => {
            return (
              <Row>
                <UserAvatar value={row?.employee?.reporting_to?.[0]} />
                <Text
                  style={{
                    ...rowText,
                    padding: 3,
                    marginLeft: 2,
                    color: '#A3A3A3',
                  }}>
                  {row?.requested_on &&
                    moment(row?.requested_on).format('DD MMM')}
                </Text>
              </Row>
            );
          },
          width: 250,
        },
        {
          header: 'Duration',
          type: 'date',
          render: ({row, styles}) => {
            let {rowText} = styles;
            return (
              <View style={{flexDirection: 'row'}}>
                <Text style={{...rowText, marginRight: 3, color: '#737373'}}>
                  {row?.from_date && moment(row?.from_date).format('DD MMM')}
                </Text>
                <Text>-</Text>
                <Text style={{...rowText, marginLeft: 3, color: '#737373'}}>
                  {row?.to_date && moment(row?.to_date).format('DD MMM')}
                </Text>
              </View>
            );
          },
          width: 250,
        },
        {
          header: 'First Half',
          render: ({row}) => {
            return (
              <Tag
                value={row?.first_attendance_type_id?.name}
                color={'#FFF7D6'}
              />
            );
          },
          width: 200,
        },
        {
          header: 'Second Half',
          render: ({row}) => {
            return (
              <Tag
                value={row?.second_attendance_type_id?.name}
                color={'#FFF7D6'}
              />
            );
          },
          width: 200,
        },
        {
          header: 'Approver',
          width: 170,
          render: ({row}) => {
            return (
              <UserAvatarChip
                value={{
                  name: row?.employee?.reporting_to?.[0]?.name,
                  color: row?.employee?.reporting_to?.[0]?.color,
                }}
              />
            );
          },
        },
        {
          header: 'Practice Head',
          width: 190,
          render: ({row}) => {
            return (
              <UserAvatarChip
                value={{
                  name: row?.practice_head?.name,
                  color: row?.practice_head?.color,
                }}
              />
            );
          },
        },
        {
          header: 'Status',
          field: 'status',
          align: 'center',
          render: renderStatus,
          visible: () => tab === 'open',
        },
      ]}
    />
  );
};

export const TourRequestTable = props => {
  let {
    navigation,
    route: {params},
    filter,
    searchValue,
    filterParams,
    periods,
    tab,
  } = props;

  const {period, ...rest} = params;
  let sort = {};
  if (tab == 'open') {
    sort = {requested_on: -1};
  } else if (tab == 'close') {
    sort = {updatedAt: -1};
  }
  params = {
    ...rest,
  };
  params = {...params, ...filterParams, periods};
  return (
    <Table
      api={'/tourrequest/self'}
      params={params}
      eventSourceId={'wfhRequest'}
      addOnFilter={filter}
      search={searchValue}
      sort={{...sort}}
      //   onRowPress={({row}) => {
      //     navigation.navigate(`update-leave-request`, {
      //       row,
      //     });
      //   }}
      columns={[
        {
          header: 'Requested On',
          type: 'date',
          render: ({row, styles: {rowText}}) => {
            return (
              <Row>
                <UserAvatar value={row?.employee?.reporting_to?.[0]} />
                <Text
                  style={{
                    ...rowText,
                    padding: 3,
                    marginLeft: 2,
                    color: '#A3A3A3',
                  }}>
                  {row?.requested_on &&
                    moment(row?.requested_on).format('DD MMM')}
                </Text>
              </Row>
            );
          },
          width: 250,
        },
        {
          header: 'Duration',
          type: 'date',
          render: ({row, styles}) => {
            let {rowText} = styles;
            return (
              <View style={{flexDirection: 'row'}}>
                <Text style={{...rowText, marginRight: 3, color: '#737373'}}>
                  {row?.from_date && moment(row?.from_date).format('DD MMM')}
                </Text>
                <Text>-</Text>
                <Text style={{...rowText, marginLeft: 3, color: '#737373'}}>
                  {row?.to_date && moment(row?.to_date).format('DD MMM')}
                </Text>
              </View>
            );
          },
          width: 250,
        },
        {
          header: 'First Half',
          render: ({row}) => {
            return (
              <Tag
                value={row?.first_attendance_type_id?.name}
                color={'#FFF7D6'}
              />
            );
          },
          width: 200,
        },
        {
          header: 'Second Half',
          render: ({row}) => {
            return (
              <Tag
                value={row?.second_attendance_type_id?.name}
                color={'#FFF7D6'}
              />
            );
          },
          width: 200,
        },
        {
          header: 'Approver',
          width: 170,
          render: ({row}) => {
            return (
              <UserAvatarChip
                value={{
                  name: row?.employee?.reporting_to?.[0]?.name,
                  color: row?.employee?.reporting_to?.[0]?.color,
                }}
              />
            );
          },
        },
        {
          header: 'Status',
          field: 'status',
          align: 'center',
          render: renderStatus,
          visible: () => tab === 'open',
        },
      ]}
    />
  );
};
